// Event dates are stored as date-only values (UTC midnight) — there's no
// meaningful time-of-day component. Passing them through `new Date(iso)` and
// then date-fns `format()`/`getFullYear()` reinterprets that UTC midnight in
// the browser's local timezone, which shifts the date back a day for anyone
// west of UTC. Build the Date from the UTC y/m/d directly using the *local*
// constructor instead, so formatting/getters never apply a timezone shift.
export function parseEventDate(iso: string): Date {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d);
}
